/**
 * The bounded applied-action set.
 *
 * CLAUDE.md invariant 9 makes delivery at-least-once, so the SDK is what turns
 * "delivered twice" into "applied once" (LIVE-004). An unbounded set would do
 * that correctly and then exhaust a browser tab during a long stream, which
 * invariant 10's "queue は必ず上限と overflow policy を持つ" rules out.
 *
 * Insertion-ordered eviction is deliberate rather than LRU. An Action lives at
 * most its TTL, so the oldest entry is also the one least likely to be
 * redelivered; touching entries on read would keep a long-dead action id alive
 * at the expense of a live one.
 */
export const DEFAULT_DEDUPE_CAPACITY = 512;
export class AppliedActionSet {
    capacity;
    entries = new Map();
    constructor(capacity = DEFAULT_DEDUPE_CAPACITY) {
        if (!Number.isInteger(capacity) || capacity < 1) {
            throw new RangeError('dedupe capacity must be a positive integer');
        }
        this.capacity = capacity;
    }
    has(actionId) {
        return this.entries.has(actionId);
    }
    /** Record an applied action. Returns false when it was already present. */
    add(actionId, appliedAtMs) {
        if (this.entries.has(actionId))
            return false;
        if (this.entries.size >= this.capacity) {
            const oldest = this.entries.keys().next();
            if (!oldest.done)
                this.entries.delete(oldest.value);
        }
        this.entries.set(actionId, appliedAtMs);
        return true;
    }
    get size() {
        return this.entries.size;
    }
    clear() {
        this.entries.clear();
    }
}
